import type { BootFlags } from './bootFlags.types';

export const BOOT_FLAG_HIDE_JOY_LOGO = 'hidejoylogo';

/**
 * Amplitude flag keys (lowercased, as Amplitude returns them) that early-boot client code
 * needs before Segment/auth/eventInfo/consent resolve. Keep this list tiny: every key is a
 * server round-trip input and lands in every SSR document.
 *
 * hidejoylogo: drives Joy-logo vs generic branding on guest-facing surfaces from the very
 * first paint (see useJoyBranding).
 */
export const BOOT_FLAG_KEYS: ReadonlyArray<keyof BootFlags & string> = [BOOT_FLAG_HIDE_JOY_LOGO];

/**
 * Amplitude omits a flag from the variants payload when the visitor isn't targeted by it, so
 * "key absent" cannot mean "server failed". Every key is emitted with a resolved value and
 * this default fills the gap, which lets the client treat a MISSING key as a real failure.
 */
export const BOOT_FLAG_DEFAULT_VALUE = 'off';
